window.SITE_DATA = {
    firmNameText: "Yesil & Partner",
    firmNameHtml: "Yesil <span class=\"amp\">&amp;</span> Partner",
    taglineHtml: "Rechtsanw\u00e4lte <span class=\"amp\">&amp;</span> Strafverteidiger",
    titleSeparator: " | ",
    street: "Werdener Str. 6",
    city: "40227 D\u00fcsseldorf",
    addressLine: "Werdener Str. 6, 40227 D\u00fcsseldorf",
    phone: "+49 211 17151749",
    email: "info@ra-yesil.de",
    emailSadak: "info@ra-sadak.de",
    emailKasim: "info@ra-kasim.de",
    hoursWeekdays: "Montag 09:00\u201313:00, 14:00\u201317:00",
    hoursTue: "Dienstag 09:00\u201313:00, 14:00\u201317:00",
    hoursWed: "Mittwoch 09:00\u201313:00",
    hoursThu: "Donnerstag 09:00\u201313:00, 14:00\u201317:00",
    hoursFri: "Freitag 09:00\u201314:00",
    lawyerKamuranEmergency: "+49 211 17151749",
    lawyerYesilEmergency: "+49 211 17151749",
    lawyerAminEmergency: "+49 211 17151749"
};

//# sourceMappingURL=amin.fbfd8211.js.map
